import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("rect", {
  x: "2",
  y: "2",
  width: "20",
  height: "20",
  rx: "2.18",
  ry: "2.18"
}), ___EmotionJSX("line", {
  x1: "7",
  y1: "2",
  x2: "7",
  y2: "22"
}), ___EmotionJSX("line", {
  x1: "17",
  y1: "2",
  x2: "17",
  y2: "22"
}), ___EmotionJSX("line", {
  x1: "2",
  y1: "12",
  x2: "22",
  y2: "12"
}), ___EmotionJSX("line", {
  x1: "2",
  y1: "7",
  x2: "7",
  y2: "7"
}), ___EmotionJSX("line", {
  x1: "2",
  y1: "17",
  x2: "7",
  y2: "17"
}), ___EmotionJSX("line", {
  x1: "17",
  y1: "17",
  x2: "22",
  y2: "17"
}), ___EmotionJSX("line", {
  x1: "17",
  y1: "7",
  x2: "22",
  y2: "7"
}));
export default SVG;